// extracted by mini-css-extract-plugin
module.exports = {"subHeaderWrap":"subHeaderWrap--CwCxd","sticky":"sticky--2dRol","title":"title--14bNh","box":"box--3-NYe"};